import { Modal } from "../theme/modal/modal";

export interface IAgeGate extends HTMLElement {
  showAgeGate(): void;
  isAgeApproved(): boolean;
}

class AgeGate extends Modal implements IAgeGate {
  private confirmButton: HTMLElement | undefined;
  private cancelButton: HTMLElement | undefined;

  constructor() {
    super();
    this.confirmButton;
    this.cancelButton;
  }

  connectedCallback(): void {
    this.cacheAgeGateDomElements();
    this.setEventListeners();
    this.handleEntryAgeGate();

    super.connectedCallback();
  }

  private cacheAgeGateDomElements(): void {
    this.confirmButton = this.querySelector(
      '[js-age-gate="confirmButton"]',
    ) as HTMLButtonElement;
    this.cancelButton = this.querySelector(
      '[js-age-gate="cancelButton"]',
    ) as HTMLButtonElement;
  }

  private setEventListeners(): void {
    this.confirmButton?.addEventListener("click", () => this.handleConfirm());
    this.cancelButton?.addEventListener("click", () => this.hideAgeGate());
  }

  private handleEntryAgeGate(): void {
    if (this.isAgeApproved()) {
      return;
    }

    const entryAgeGateEnabled =
      this.getAttribute("settings-entry-gate-enabled") === "true";
    const entryAgeGateDelay =
      this.getAttribute("settings-entry-gate-delay") || 0;

    if (!entryAgeGateEnabled) {
      return;
    }

    setTimeout(() => {
      super.showModal();
    }, Number(entryAgeGateDelay));
  }

  private handleConfirm(): void {
    document.dispatchEvent(new Event("ageGate:approved"));

    this.setLocalStorage();
    this.hideAgeGate();
  }

  public showAgeGate(): void {
    if (this.isAgeApproved()) {
      return;
    }

    super.showModal();
  }

  private hideAgeGate(): void {
    super.hideModal();
  }

  private setLocalStorage(): void {
    localStorage.setItem("ageGateApproved", "true");
  }

  public isAgeApproved(): boolean {
    const ageGateApproved = localStorage.getItem("ageGateApproved");

    if (ageGateApproved) {
      return true;
    }

    return false;
  }
}

customElements.define("uwp-age-gate", AgeGate);
